import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  SwiperOptions
} from 'swiper';
import Controler from '../base/Controler';

class SliderControler extends Controler {
  constructor() {
    super();
    this.init();
  }

  init(): void {
    this.selectElements('.js-swiper').forEach(el => {
      const config = el.dataset.swiperConfig || 'default';
      const swiper = new Swiper(el, this.config(config, el));
    });
  }

  private config(settings: string, el: HTMLElement): SwiperOptions {
    const parent = el.parentElement;
    const secondPagination = el.querySelector('.swiper__second-pagination');

    const updateSecondPagination = (
      curentSlide: number,
      total: number
    ): void => {
      if (secondPagination)
        secondPagination.innerHTML = `${curentSlide}/${total}`;
    };

    let config: SwiperOptions = {
      speed: 600,
      navigation: {
        nextEl: parent.querySelector('.swiper__button--next') as HTMLElement,
        prevEl: parent.querySelector('.swiper__button--prev') as HTMLElement
      }
    };

    if (settings === 'default') {
      Swiper.use([Pagination, Navigation, Autoplay]);
      config = {
        ...config,
        loop: false,
        spaceBetween: 40,
        pagination: {
          el: '.swiper__pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000
        },
        breakpoints: {
          767: {
            allowTouchMove: false
          }
        }
      };
    }

    if (settings === 'partners') {
      Swiper.use([Pagination, Navigation, Autoplay]);
      config = {
        ...config,
        loop: false,
        spaceBetween: 24,
        slidesPerView: 2,
        pagination: {
          el: '.swiper__pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000
        },
        breakpoints: {
          767: {
            allowTouchMove: false,
            slidesPerView:
              el.querySelectorAll('.swiper-slide')?.length > 2 ? 3 : 2
          }
        }
      };
    }

    if (settings === 'shop') {
      Swiper.use([Navigation, Pagination, Autoplay]);
      config = {
        ...config,
        loop: false,
        spaceBetween: 40,
        pagination: {
          el: '.swiper__pagination',
          clickable: true
        },
        autoHeight: true,
        // autoplay: {
        //   delay: 5000
        // },
        on: {
          breakpoint(swiper) {
            setTimeout(() => {
              swiper.update();
            }, 0);
          },
          activeIndexChange(swiper) {
            updateSecondPagination(
              swiper.activeIndex + 1,
              swiper.slides.length
            );
          },
          init(swiper) {
            updateSecondPagination(
              swiper.activeIndex + 1,
              swiper.slides.length
            );
          }
        },
        breakpoints: {
          767: {
            slidesPerView: 'auto',
            spaceBetween: 24,
            allowTouchMove: false,
            autoHeight: false
          }
        }
      };
    }

    return config;
  }
}

export default SliderControler;
